import {ViewBase} from "@/rawdogjs/src/core/viewBase";
import {IView} from "@/rawdogjs/src/interfaces/IView";
import {TopBarPresenter} from "./topBarPresenter";
import {Router} from "@/rawdogjs/src/router";
import {ParcelDependencyContainer} from "@/rawdogjs/src/core/ParcelDependencyContainer";

export class TopBarView extends ViewBase implements IView {

    public _presenter: TopBarPresenter;
    
    public set appTitle(appTitle){
        this.setText('.app-title', appTitle);
    }
    
    public set displayName(displayName){
        this.setTextById('display-name', displayName);
    }
    
    public set handle(handle){
        this.setTextById('handle-name', handle);
    }
    
    public showLoggedIn(value){
        this.setElementVisibility('#not-logged-in', !value);
        this.setElementVisibility('#logged-in', value);
    }


    constructor(viewName: string, router: Router, dependencyContainer: ParcelDependencyContainer, presenter: TopBarPresenter) {
        super(viewName, router, dependencyContainer);
        this._presenter = presenter;
    }

    public setPresenter(presenter: TopBarPresenter) {
        this._presenter = presenter;
    }

    public render(): void {
    }

}